import regeneratorRuntime from "regenerator-runtime";
import Utilitiesjs from '../utilites';
import Ajaxjs from '../ajax';
import { join } from "path";

export default class CertifiedMembersList {
    constructor() {
        this.utilsjs = new Utilitiesjs;
        this.ajaxjs = new Ajaxjs;
    }

    init(data) {
        const that = this;

        that.certifiedMembers = data.IdentityUsers;
        that.filterRoles = data.FilterRoles
        that.displayFilterResult(data.IdentityUsers);

        document.querySelectorAll(
            `input[name=certifiedMemberRoleFilter],
            #certifiedMemberNoPreFilter,
            input[name = certifiedMemberFlagFilter]`)
            .forEach(ele => {
                ele.onclick = () => that.search();
            });
    };

    search() {

        const that = this;

        var noPreFilter = document.getElementById("certifiedMemberNoPreFilter").checked;

        const key = document.getElementById("keyword").value.toLowerCase();
        let memberFilterRoles = [];

        document.querySelectorAll("input[name=certifiedMemberRoleFilter]:checked").forEach(ele => {
            memberFilterRoles.push(ele.value.toLowerCase());
        });

        let memberFilterFlags = [];

        document.querySelectorAll("input[name=certifiedMemberFlagFilter]:checked").forEach(ele => {
            memberFilterFlags.push(ele.value.toLowerCase());
        });


        let certifiedMembersFilter = [...that.certifiedMembers]
            .filter(member => member.MemberName.toLowerCase().includes(key)
                && (noPreFilter ||
                    (
                        (memberFilterRoles.length === 0 || memberFilterRoles.includes(member.Role.toLowerCase()))
                        &&//||
                        that.filterFlags(memberFilterFlags, member)
                    ))
            );

        that.displayFilterResult(certifiedMembersFilter);
    }

    filterFlags(memberFilterFlags, member) {
        const filterFlagLength = memberFilterFlags.length;

        if (filterFlagLength > 0) {
            for (let i = 0; i < filterFlagLength; i++) {
                if (member[memberFilterFlags[i]] == true) { //Only one true
                    return true;
                }
                //if (member[memberFilterFlags[i]] != true) { // Need all true
                //    return false;
                //}
            }
            return false;
            //return true; // Need all true
        } else {
            return true;
        }


    }

    displayFilterResult(certifiedMembers) {
        let that = this;
        let role = "";
        let userMap = "";
        let roles = that.filterRoles;

        const certifiedMemberFilterResult = certifiedMembers.map((member, index ) => {

            if (userMap !== member.Role) {
                roles.forEach((r) => {
                    if (r.IdentityUserMap === member.Role) {
                        role = r.Name;
                        userMap = r.IdentityUserMap;
                    }
                });
                if (index === 0) {
                    return `<br/><div>
                        <div class="cscp-header-bold">${role}</div>
                        
                            ${member.MemberName}<br/>`;
                }
                return (!role ? "" : "</div><br/><hr/><br/>") +
                    `<div>
                        <div class="cscp-header-bold">${role}</div>
                        
                            ${member.MemberName}<br/>`;
            } else {
                return `${member.MemberName}<br/>`;
            }
        });

        document.getElementById("certifiedMemberFilterResult").innerHTML = certifiedMemberFilterResult.join("");
    }

}


// WEBPACK FOOTER //
// ./Scripts/es6/controllers/certifiedMembersList.js